import React, { useState } from "react";
import PropTypes from "prop-types";

const SecureFilePicker = ({ onSelect, buttonText, accept = "image/png,image/jpeg,application/pdf" }) => {
  const [filename, setFilename] = useState("");

  const handleChange = (event) => {
    const file = event.target.files?.[0] || null;
    setFilename(file?.name || "");
    onSelect(file);
  };

  return (
    <label className="btn" style={{ cursor: "pointer", display: "inline-block" }}>
      {filename || buttonText}
      <input type="file" accept={accept} onChange={handleChange} style={{ display: "none" }} />
    </label>
  );
};

SecureFilePicker.propTypes = {
  onSelect: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  accept: PropTypes.string,
};

export default SecureFilePicker;
